<template>
  <div class="xcard">
    <h3 class="text-center" style="margin-top:0"> Dashboard de Programas</h3>
    <p class="text-center text-primary"> <small>Apertura de programas por sede.</small> </p>

     <Sedes :model="sede" :tosedes="sedes" style="display:none"/>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group form-group-sm">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> Gestion: </div>
            <Gestiones :model="gestion" :default="gestion.gestion"/>
          </div>
        </div>
      </div>
    </div>

    <button class="btn btn-sm btn-link" @click="cambiar()"> <span class="glyphicon glyphicon-signal"></span> Cambiar Grafico</button>

    <div class="row">
      <div class="col-sm-9">
        <canvas id="planet-chart"></canvas>
      </div>

      <div class="col-sm-3">
        <p v-if="datos.length>0" class="text-center text-success">Aperturas:</p>
        <div v-bind:key="ind" v-for="(i,ind) in datos" style="font-size:12px;margin-bottom:12px">
          <p class="text-primary" style="margin-bottom:0"> <b>Esam {{i.sede}}:</b> </p>
          <b style="margin-left:28px">Dip:</b> <span>{{ i.dip }}, </span> 
          <b>Esp:</b> <span>{{ i.esp }}, </span> 
          <b>Msc:</b> <span>{{ i.mae }}</span>
        </div>
      </div>
    </div>

    <Alertas ref="alertar" />
    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
import {parseJsonError} from '@/components/Utils.js'
import Sedes from '@/components/ASedes'
import Alertas from '@/components/AAlertas.vue'
import Gestiones from '@/components/AGestiones'
import gql from 'graphql-tag'
import Chart from 'chart.js';
export default {
  data(){
    return{
      sede: {idsede:null},
      gestion: {gestion:{gestion:null}},
      semaforo: {idsemaforo:{}},
      sedes:{sedes:[]},
      datos: [],
      semaforos: [],
      labeles: [],
      labeles2: [],
      diplomados: [],
      especialidades: [],
      maestrias: [],
      char: null,

      planetChartData: {
        type: 'bar',
        data: {
          labels: [],
          datasets: [
            {
              label: 'Diplomados',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 3
            },
            {
              label: 'Especialidades',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 3
            },
            {
              label: 'Maestrias',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 3
            }
          ]
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                padding: 25,
              }
            }]
          }
        }
      }


    }
  },
  components:{ Sedes,Gestiones,Alertas },
  watch:{
    'gestion.gestion':function(){
      this.listener();
    },
    'sedes.sedes':{
      deep:true,
      handler(){
        this.listener();
      }
    }
  },
  methods:{
    listener(){
      if( this.sedes.sedes.length == 0 || this.gestion.gestion == null ) return;
      var vue = this;
      var sql = 'query{';
      this.labeles = [];
      this.labeles2 = [];
      this.sedes.sedes.forEach( function(e){
        var n = e.nombre;
        var se = e.nombre;
        se = se.replace("Esam","");
        se = se.replace("ESAM","");
        if( !n.includes('Formac')){
          n = n.replace(' ','_').toLowerCase();
          n = n.replace(' ','_');
          n = n.replace('í','i')
          sql += n+':getProgramas(idsede:'+e.id+',gestion:'+vue.gestion.gestion.gestion+'){fase,postgrado{categoria{nombre}}} ';
          vue.labeles.push( se );
          vue.labeles2.push( n );
        }
      });
      sql += `}`;
      //window.console.log( 'kkkkkkkkkkk',sql);
      sql = gql`${sql}`;
      //window.console.log( 'kkkkkkkkkkk',sql);
      this.getInscripciones( sql );
    },
    cambiar(){
      if( this.planetChartData.type == "bar" ) this.planetChartData.type = "line";
      else this.planetChartData.type = "bar";
      this.createChart( 'planet-chart',this.planetChartData )
    },

    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      if( this.char ) this.char.reset();

      this.char = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
      this.$refs.alertar.reset();
    },
    async getInscripciones( sql ){
      this.$refs.alertar.cargando();
      await this.$apollo.query({
        query: sql,
        }).then((data) => {
          var lista = data.data;
          this.datos = [];
          this.diplomados = [];
          this.especialidades = [];
          this.maestrias = [];
          var cd = []; var bd = [];
          var ce = []; var be = [];
          var cm = []; var bm = [];

          var vue = this;
          this.labeles2.forEach(function(e,i){
            var d = 0;
            var x = 0;
            var m = 0;
            var otros = 0;
            cd.push( '#1976d2' );
            ce.push( '#f9a825' );
            cm.push( '#43a047' );
            bd.push( '#004ba0' );
            be.push( '#c17900' );
            bm.push( '#00701a' );

            lista[e].forEach( function(f){
              if( f.fase != 4 ){ // cerrados no tomar en cuenta
                if( f.postgrado.categoria.nombre.includes('Diplomado') ) d++;
                else if( f.postgrado.categoria.nombre.includes('Especialidad') ) x++;
                else if( f.postgrado.categoria.nombre.includes('Maestr') ) m++; 
                else otros++;
              }
            });
            vue.datos.push( {sede:vue.labeles[i],nombre:vue.labeles2[i],dip:d,esp:x,mae:m} );
            vue.diplomados.push(d);
            vue.especialidades.push(x);
            vue.maestrias.push(m);
            window.console.log('OTROS::',otros)
          });
          /*window.console.log( vue.datos );
          window.console.log( vue.diplomados );
          window.console.log( vue.especialidades );
          window.console.log( vue.maestrias );*/

          vue.planetChartData.data.labels = vue.labeles;
          vue.planetChartData.data.datasets[0].data = vue.diplomados;
          vue.planetChartData.data.datasets[0].backgroundColor = cd;
          vue.planetChartData.data.datasets[0].borderColor = bd;
          vue.planetChartData.data.datasets[1].data = vue.especialidades;
          vue.planetChartData.data.datasets[1].backgroundColor = ce;
          vue.planetChartData.data.datasets[1].borderColor = be;
          vue.planetChartData.data.datasets[2].data = vue.maestrias;
          vue.planetChartData.data.datasets[2].backgroundColor = cm;
          vue.planetChartData.data.datasets[2].borderColor = bm;
          vue.createChart( 'planet-chart',vue.planetChartData )
          
        }).catch((error) => {
          window.console.error(error)
          this.$notify( parseJsonError( error,'getInscripcionesByUser' ) )
        })
    },
  },
  mounted(){
    this.gestion.gestion.gestion = new Date().getFullYear();
    this.$refs.alertar.cargando();
    //this.createChart( 'planet-chart',this.planetChartData )
  }
}
</script>